
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {
  components: {
    'component-dropzone': () => import(/* webpackChunkName: "components" */ '../dropzone'),
    'component-button': () => import(/* webpackChunkName: "components" */ '../Button.vue'),
  },

  data: () => ({
    store,
    files: null,
    doneAnalysing: false,
    isValid: false
  }),
  
  computed: {
    ...mapGetters([
      'multipleTransfers'
    ]),

    paramName () {
      return store.modal.dataModel.paramName || 'files'
    },

    hasMultipleFiles () {
      if (store.modal.dataModel.hasOwnProperty('multipleFiles')) {
        return !!store.modal.dataModel.multipleFiles
      } else {
        return true
      }
    },

    numberOfTransfers () {
      return this.multipleTransfers.length
    },

    totalAmount () {
      let total = 0
      this.multipleTransfers.forEach(value => {
        total += parseFloat(value.transfer.amount)
      })
      return total
    },
    
    isLocal () {
      return !!store.modal.dataModel.isLocal
    },

    getLabel () {
      if (this.isValid) {
        return this.$i18n.tc('modal.join_transfers_document.success.label')
      } else {
        return this.$i18n.t('modal.join_transfers_document.error.label')
      }
    },

    getContent () {
      if (this.isValid) {
        return this.$i18n.tc('modal.join_transfers_document.success.content', this.numberOfTransfers, { numberOfTransfers: this.numberOfTransfers, totalAmount: this.totalAmount })
      } else {
        return this.$i18n.t('modal.join_transfers_document.error.content')
      }
    }
  },
  
  mounted () {
    this.$bus.$on('files-changed', this.onFilesChanged)
  },
  
  destroyed () {
    this.$bus.$off('files-changed', this.onFilesChanged)
  },
  
  methods: {
    ...mapActions([
      'getMultipleTransfers'
    ]),

    onCloseModal () {
      store.modal.active = false
    },
    
    onAddFiles () {
      this.getMultipleTransfers(this.files).then(() => {
        this.addClass()
        this.doneAnalysing = true
        this.isValid = true
      }, () => {
        this.addClass()
        this.doneAnalysing = true
        this.isValid = false
      })
    },

    addClass () {
      document.getElementById('modal').classList.add('modal-multiple-transfer')
    },

    onFilesChanged (files) {
      if (files[0]) {
        this.files = files[0]
      } else {
        this.files = null
      }
    },

    onValidate () {
      this.$bus.$emit('validate-multiple-transfer-file')
      this.onCloseModal()
    }
  }
}
